package com.isaias.fyattravel.web.pages.explore

import androidx.compose.runtime.Composable
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*
import com.isaias.fyattravel.web.components.LazyImage

private data class ShowcasePhoto(val src: String, val alt: String, val caption: String)

private val SHOWCASE_PHOTOS = listOf(
    ShowcasePhoto(
        "images/explore/wildlife/mountain-gorilla.jpg",
        "Mountain gorilla in Bwindi Impenetrable Forest",
        "Mountain Gorillas · Bwindi"
    ),
    ShowcasePhoto(
        "images/explore/wildlife/african-elephant.jpg",
        "African elephant walking through golden savanna grass",
        "Elephants · Queen Elizabeth"
    ),
    ShowcasePhoto(
        "images/explore/wildlife/lion.jpg",
        "Lions walking across the savanna in Queen Elizabeth National Park",
        "Big Cats · Queen Elizabeth"
    ),
    ShowcasePhoto(
        "images/explore/wildlife/chimpanzee.jpg",
        "Chimpanzee in the rainforest canopy of Kibale Forest",
        "Chimpanzees · Kibale Forest"
    ),
    ShowcasePhoto(
        "images/explore/landscapes/savanna-sunset.jpg",
        "Golden savanna grassland at sunset in Uganda",
        "Savanna at Dusk"
    ),
    ShowcasePhoto(
        "images/explore/landscapes/rolling-hills-uganda.jpg",
        "Rolling green hills and banana plantations in western Uganda",
        "The Pearl of Africa"
    ),
    ShowcasePhoto(
        "images/explore/waterfalls/murchison-falls.jpg",
        "The Nile crashing through the gorge at Murchison Falls, Uganda",
        "Murchison Falls · The Nile"
    ),
    ShowcasePhoto(
        "images/explore/waterfalls/murchison-falls-rainbow.jpg",
        "Rainbow over the mist at Murchison Falls, Uganda",
        "Murchison Falls · The Gorge"
    ),
)

@Composable
fun ImageShowcaseSection() {
    Div({
        style {
            padding(3.em, 1.5.em)
            property("margin", "0 auto")
            maxWidth(1200.px)
        }
    }) {
        EyebrowLabel("Nature · Wildlife · Waterfalls")
        H2({
            style {
                fontSize(1.8.em)
                fontWeight("800")
                margin(0.35.em, 0.em, 1.em, 0.em)
                color(Color("#141210"))
            }
        }) { Text("The Uganda you'll actually see") }

        Div({
            style {
                property("display", "grid")
                property("grid-template-columns", "repeat(auto-fit, minmax(240px, 1fr))")
                gap(0.75.em)
            }
        }) {
            SHOWCASE_PHOTOS.forEach { photo ->
                Div({
                    style {
                        position(Position.Relative)
                        borderRadius(0.9.em)
                        overflow("hidden")
                        height(220.px)
                    }
                }) {
                    LazyImage(src = photo.src, alt = photo.alt) {
                        width(100.percent)
                        height(100.percent)
                    }
                    // bottom scrim, matching the flights-hero caption technique
                    Div({
                        style {
                            position(Position.Absolute)
                            left(0.px); right(0.px); bottom(0.px)
                            height(55.percent)
                            property(
                                "background",
                                "linear-gradient(to top, rgba(0,0,0,0.62) 0%, rgba(0,0,0,0.26) 40%, rgba(0,0,0,0) 100%)"
                            )
                            property("pointer-events", "none")
                        }
                    })
                    Span({
                        classes("explore-caption")
                    }) { Text(photo.caption) }
                }
            }
        }
    }
}

@Composable
internal fun EyebrowLabel(text: String) {
    Span({
        style {
            display(DisplayStyle.InlineBlock)
            fontSize(0.72.em)
            fontWeight("600")
            letterSpacing(0.22.em)
            property("text-transform", "uppercase")
            color(Color("#AE7930"))
        }
    }) { Text(text) }
}
